import type { FC } from 'react';
import React, { memo, useEffect } from 'react';
import { getActions, withGlobal } from '../../global';

import type { ApiGroupCall, ApiUser } from '../../api/types';

import {
  selectActiveGroupCall,
  selectPhoneCallUser,
} from '../../global/selectors/calls';
import { selectTabState } from '../../global/selectors';
import buildClassName from '../../util/buildClassName';
import useLang from '../../hooks/useLang';

import './ActiveCallHeader.scss';

type StateProps = {
  isCallPanelVisible?: boolean;
  groupCall?: ApiGroupCall;
  phoneCallUser?: ApiUser;
};

const ActiveCallHeader: FC<StateProps> = ({
  groupCall,
  phoneCallUser,
  isCallPanelVisible,
}) => {
  const { toggleGroupCallPanel } = getActions();

  const lang = useLang();

  useEffect(() => {
    document.body.classList.toggle(
      'has-call-header',
      Boolean(isCallPanelVisible)
    );

    return () => {
      document.body.classList.toggle('has-call-header', false);
    };
  }, [isCallPanelVisible]);

  function handleToggleGroupCallPanel() {
    toggleGroupCallPanel();
  }

  if (!groupCall && !phoneCallUser) return undefined;

  return (
    <div
      className={buildClassName(
        'ActiveCallHeader',
        isCallPanelVisible && 'open'
      )}
      onClick={handleToggleGroupCallPanel}
    >
      <span className='title'>
        {phoneCallUser?.firstName ||
          groupCall?.title ||
          lang('VoipGroupVoiceChat')}
      </span>
    </div>
  );
};

export default memo(
  withGlobal((global): StateProps => {
    const tabState = selectTabState(global);
    return {
      groupCall: tabState.isMasterTab
        ? selectActiveGroupCall(global)
        : undefined,
      isCallPanelVisible: tabState.isCallPanelVisible,
      phoneCallUser: tabState.isMasterTab
        ? selectPhoneCallUser(global)
        : undefined,
    };
  })(ActiveCallHeader)
);
